import React, { FC, InputHTMLAttributes } from 'react';
import styles from './CustomNumberInput.module.scss';

interface CustomNumberInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: boolean;
  errorMessage?: string;
  min?: number;
  max?: number;
}

const CustomNumberInput: FC<CustomNumberInputProps> = ({
  label,
  error,
  errorMessage,
  min,
  max,
  ...props
}) => {
  return (
    <div className={styles.wrapper}>
      {label && <label htmlFor={label} className={styles.label}>{label}</label>}
      <input
        type="number"
        className={`form-control ${error && 'errorInput'}`}
        min={min}
        max={max}
        {...props}
      />
      {error && errorMessage && (
        <span className={styles.errorMessage}>{errorMessage}</span>
      )}
    </div>
  );
};

export default CustomNumberInput;